/* eslint-disable react/display-name */
import { matchSorter } from 'match-sorter';
import React from 'react';
import dayjs from 'dayjs';

export function createCourierColumns() {
  const columns = [
    {
      id: 'id',
      Header: 'Delivery',
      accessor: 'id',
      minWidth: 70,
      maxWidth: 70,
      filterable: false,
      Cell: ({ value }) => (
        <span className="react-table-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`/deliveries/${value}`}
          >
            {value}
          </a>
        </span>
      ),
    },
    {
      id: 'orderIds',
      Header: 'Orders',
      accessor: 'orderIds',
      minWidth: 60,
      maxWidth: 60,
      filterable: false,
      Cell: ({ value }) =>
        value.map((orderId, key) => (
          <span key={key} className="react-table-link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="react-table-link"
              href={`/orders/${orderId}`}
            >
              {orderId}
            </a>
          </span>
        )),
    },
    {
      Header: 'Date delivered',
      id: 'deliveryDate',
      resizable: true,
      accessor: 'deliveryDate',
      minWidth: 60,
      maxWidth: 100,
      filterable: false,
      Cell: ({ value }) => <span>{dayjs(value).format('YYYY-MM-DD')}</span>,
    },
    {
      Header: 'Sender Name',
      id: 'senderNames',
      accessor: 'senderNames',
      minWidth: 40,
      maxWidth: 100,
      resizable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['senderNames'] }),
      Cell: ({ value }) => String(value.join(', ')),
      filterAll: true,
    },
    {
      Header: 'Courier Name',
      id: 'courierName',
      accessor: 'courierName',
      minWidth: 80,
      maxWidth: 260,
      resizable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['courierName'] }),
      filterAll: true,
    },
    {
      Header: 'Rating',
      id: 'rating',
      accessor: 'rating',
      minWidth: 30,
      maxWidth: 80,
      resizable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['rating'] }),
      filterAll: true,
    },
    {
      Header: 'Feedback',
      id: 'feedback',
      accessor: 'feedback',
      minWidth: 100,
      maxWidth: 300,
      resizable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['feedback'] }),
      filterAll: true,
    },
    {
      Header: 'Reasons',
      id: 'feedbackFlags',
      accessor: 'feedbackFlags',
      minWidth: 100,
      maxWidth: 300,
      resizable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['feedbackFlags'] }),
      Cell: ({ value }) => String(value.join(', ')),
      filterAll: true,
    },
    {
      Header: 'Mottaker',
      id: 'recipientName',
      accessor: 'recipientName',
      minWidth: 80,
      maxWidth: 120,
      resizable: true,
      filterable: false,
    },
    {
      Header: 'Recipient Address',
      id: 'recipientAddress',
      accessor: 'recipientAddress',
      minWidth: 80,
      maxWidth: 260,
      resizable: true,
      filterable: false,
    },
    {
      Header: 'Region',
      id: 'region',
      accessor: 'region',
      minWidth: 40,
      maxWidth: 100,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['region'] }),
      filterAll: true,
    },
  ];
  return columns;
}
